<template>
  <fragment>
    <div class="dropdown" :class="{'d-inline': inline}">
      <button id="share_btn" class="btn btn-ss dropdown-toggle"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false">
        <i class="la la-share-alt" />
      </button>
      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="share_btn">
        <b-dropdown-item-button v-for="link in getPodcastShareLinks()"
                                :key="`podcast_share_${link.key}_${podcast.uuid}`"
                                @click="link.callback(podcast)">
          <i :class="link.icon" /> {{ link.label }}
        </b-dropdown-item-button>
      </div>
    </div>
    <preview-modal name="preview-podcast" :is-feed="true" :entity="podcast" />
  </fragment>
</template>

<script>

import SocialShareMixin from "VueMixins/SocialShareMixin";
import PreviewModal from "VueModals/PreviewModal";

export default {
  components: { PreviewModal },
  mixins: [SocialShareMixin],
  props: {
    podcast: {
      type: Object,
      required: true,
    },
    inline: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
